import { colors } from '@insurancemenu/imenu-components-lib';
import styled, { css, CSSProp } from 'styled-components';
import { EligibilityStatus } from 'types/uwService';

interface ProductSummaryStylesProps {
  $side: 'left' | 'right';
}

interface RatesBlockStylesProps {
  $eligibilityStatus?: EligibilityStatus;
}

export const ProductSummaryStyled = styled.div<ProductSummaryStylesProps>`
  width: 40%;
  ${({ $side }): CSSProp => {
    if ($side === 'left') {
      return css`
        padding-right: 10%;
        border-right: 0.1rem solid #c1c7cd;
      `;
    }
    return 'padding-left: 10%;';
  }}
`;

export const RatesNameStyled = styled.h4`
  font-size: 1.4rem;
  line-height: 1.8rem;
  font-weight: 500;
  letter-spacing: 0.05rem;
  padding: 0 0 0.8rem;
  margin: 0 0 1.6rem;
  text-align: center;
  border-bottom: 0.1rem solid #c1c7cd;
  text-transform: uppercase;
`;

export const RatesListStyled = styled.ul<RatesBlockStylesProps>`
  display: flex;
  flex-direction: column;
  padding: 0;
  list-style: none;
  margin: 0;
  border-radius: 6px;
  ${({ $eligibilityStatus }): CSSProp => {
    switch ($eligibilityStatus) {
      case 'ELIGIBLE':
        return css`
          background-color: ${colors.green[100]};
        `;
      case 'UPDATED_RATES':
        return css`
          background-color: ${colors.yellow[100]};
        `;
      case 'OVERRIDE':
        return css`
          background-color: #f4f0ff;
        `;
      default:
        return css`
          background-color: ${colors.neutral[100]};
        `;
    }
  }}
`;

export const RatesItemStyled = styled.li`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.8rem 1.2rem;
`;

export const RateNameStyled = styled.span`
  font-size: 1.4rem;
  line-height: 2rem;
  font-weight: 400;
  letter-spacing: 0.02rem;
`;

export const RateValueStyled = styled.span`
  font-size: 1.6rem;
  line-height: 2.4rem;
  font-weight: 700;
  letter-spacing: 0.02rem;
  color: ${colors.green[600]};
`;

export const NotEligibleRatesStyled = styled.li<{ $ratesQuantity: number }>`
  ${({ $ratesQuantity }): CSSProp => {
    return css`
      height: ${$ratesQuantity * 4}rem;
    `;
  }}
  border-radius: 0.6rem;
  font-size: 1.4rem;
  line-height: 2rem;
  font-weight: 400;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${colors.red[600]};
  background-color: ${colors.red[100]};
`;

export const BrowsingCriteriaBlockStyled = styled.div`
  margin-top: 1.6rem;
  border-top: 1px solid ${colors.neutral[400]};
`;

export const BrowsingCriteriaTextStyled = styled.p`
  font-size: 1.4rem;
  line-height: 2rem;
  font-weight: 400;
  color: ${colors.neutral[700]};
  background-color: ${colors.neutral[100]};
  margin-top: 1.6rem;
  letter-spacing: 0.02rem;
  padding: 0.8rem 1.2rem;
  border-radius: 6px;
`;

export const NotEligibleBrowsingCriteriaStyled = styled.p`
  font-size: 1.4rem;
  line-height: 2rem;
  font-weight: 400;
  color: ${colors.red[600]};
  background-color: ${colors.red[100]};
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  padding: 0.8rem 1.2rem;
`;
